import { buscarDashboard } from '../../interfaces/dashboard';
import BASEURLPROJETOS from '../api/projetos'

export function listarDashboard({ idProjeto, dataInicial, dataFinal, situacao }: buscarDashboard) {
  return BASEURLPROJETOS.get(`/dashboard?idProjeto=${idProjeto}&dataInicial=${dataInicial}&dataFinal=${dataFinal}&situacao=${situacao}`);
}